module.exports = __webpack_public_path__ + "img/custom-design.dbf115c0.png";